import { Instagram, MessageCircle } from "lucide-react";
import { socialLinks } from "../style_palete";
import { palette } from "../style_palete";


export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-[#D7E1EA] "
    style={{ backgroundColor: palette.sky }}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          
          {/* Logo y nombre */}
          <div
            className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img 
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhFmorPDGVUU8g88S9g-fjXqwrNzMnbD2OGQ&s" 
              alt="Kalmares BA"
              className="h-8 w-8 rounded-full shadow-md object-cover"
            />
            
            <span className="font-semibold text-slate-800">
              Kalmares BA
            </span>
          </div>


          {/* Enlaces rápidos */}
          <nav className="flex flex-wrap justify-center gap-6 text-sm text-slate-600">
            <a 
              href="#servicios" 
              className="hover:text-slate-800 hover:font-medium transition-colors"
            >
              Especialidades
            </a>
            <a 
              href="#equipo" 
              className="hover:text-slate-800 hover:font-medium transition-colors"
            >
              Equipo
            </a>
            <a 
              href="#contacto" 
              className="hover:text-slate-800 hover:font-medium transition-colors"
            >
              Contacto
            </a>
              <a href="#obras-sociales" 
              className="hover:text-slate-800 hover:font-medium transition-colors"
              >
              Obras Sociales
            </a>
            <a 
              href={socialLinks.whatsapp} 
              target="_blank" 
              rel="noreferrer" 
              className="hover:text-slate-800 hover:font-medium transition-colors"
            >
              Turnos
            </a>
          </nav>

          {/* Redes sociales */}
          <div className="flex items-center gap-4">
            <a 
              href={socialLinks.instagram} 
              target="_blank" 
              rel="noreferrer" 
              className="text-slate-600 hover:text-slate-800 p-2 rounded-full hover:bg-white transition-all"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a 
              href={socialLinks.whatsapp} 
              target="_blank" 
              rel="noreferrer" 
              className="text-slate-600 hover:text-slate-800 p-2 rounded-full hover:bg-white transition-all"
            >
              <MessageCircle className="h-5 w-5" />
            </a>
          </div>
        </div>

        {/* Línea separadora */}
        <div className="border-t border-slate-200/50 my-4"></div>

        {/* Créditos finales */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-600">
          <div>
            © {currentYear} Kalmares BA. Todos los derechos reservados.
          </div>

          <div className="w-full text-center text-slate-700 mt-2">
            Desarrollado por{" "}
            <span className="font-semibold text-slate-800">
              Juan Marcelo Chaves
            </span>{" "}
            y{" "}
            <span className="font-semibold text-slate-800">
              Daniela Grisel Vecino
            </span>.
          </div>
        </div>
      </div>
    </footer>
  );
}